<template>
  <div>
    <div v-if="isLoading" class="campaign-card-wrapper bg-black">
    </div>
    <div v-else-if="this.campaignExist">
      <div class="campaign-card-wrapper" :style="backgroundStyle">
        <div class="campaign-container container">
          <div class="row">
            <div class="col-12 col-xl-7 pb-4">
              <div class="campaign-title pb-4">{{ this.bannerTitle }}</div>
              <div>
              <span class="campaign-btn" @click="navigateToCampaignPost">
                {{ this.bannerLink ? this.bannerLink.description : "" }}
              </span>
              </div>
            </div>
            <!--     The below is commented for the pilot purpose, will be revisited after pilot       -->
            <!--  <div class="col-12 col-xl-5 campaign-date pt-2">
                <div class="d-flex justify-content-start justify-content-md-end">
                            <div class="date-text">{{ getDateStr(this.bannerDate) }}</div>
                          </div>
              <div class="d-flex justify-content-start justify-content-md-end">
                <div @click="navigateToCalendar" class="campaign-addition-link">
                  {{ this.bannerAdditionalInfo ? this.bannerAdditionalInfo.description : "" }}
                </div>
              </div>
            </div> -->    
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="campaign-card-wrapper" :style="backgroundStyle">
        <div class="campaign-container container">
          <div class="campaign-title d-flex justify-content-center">
            <div>{{ homepageHeaderGreeting }}</div>
          </div>
          <div class="greeting text-center justify-content-center">
            <div> {{ CONSTANTS.HOMEPAGE_GENERIC_GREETING }}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment/moment";
import {mapGetters} from "vuex";
import * as CONSTANTS from '../../store/constants'
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";

export default {
  name: "campaign-card",
  mixins: [HomebaseMixpanelMixin],
  data() {
    return {
      CONSTANTS,
      imgData: null,
      bannerTitle: null,
      bannerLink: null,
      bannerDate: null,
      bannerAdditionalInfo: null,
      campaignExist: false,
      isLoading: false
    };
  },
  created() {
    this.initializeCampaignCard();
  },
  computed: {
    backgroundStyle() {
      let gradientPrefix = 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)),';
      let defaultImgUrl = CONSTANTS.HOMEPAGE_DEFAULT_HERO_IMG;
      return this.imgData ? {
        'background-image': `${gradientPrefix} url(${this.imgData.url})`,
        'background-position': '50% 50% !important'
      } : {'background-image': `${gradientPrefix} url(${defaultImgUrl})`, 'background-position': '25% 43% !important'};
    },
    ...mapGetters([
      "user"
    ]),
    homepageHeaderGreeting() {
      if (!this.user || !this.user.firstName || !this.user.lastName) {
        return CONSTANTS.HOMEPAGE_GENERIC_GREETING;
      }
      let formattedFirstName = this.user.firstName;
      let firstNameArr = formattedFirstName.split(" ");
      if (firstNameArr) {
        formattedFirstName = firstNameArr[0];
      }
      return `Welcome ${formattedFirstName},`;
    },
  },
  methods: {
    async initializeCampaignCard() {
      this.isLoading = true;
      let campaignInfoResponse = await api.getCampaignInfo();
      let mostRecentCampaign = this.checkIfCampaignExist(campaignInfoResponse);

      if (this.campaignExist) {
        this.bannerTitle = mostRecentCampaign.fields.BannerTitle;
        await getCampaignBannerImage.call(this, mostRecentCampaign);
        getBannerLinkDetails.call(this, mostRecentCampaign);
        getBannerAdditionalDetails.call(this, mostRecentCampaign);
      }

      this.isLoading = false;
    },
    checkIfCampaignExist(campaignInfoResponse) {
      let mostRecentCampaign;
      if (campaignInfoResponse) {
        const currentDate = moment(new Date()).local().format('YYYY-MM-DD');

        const availableCampaigns = campaignInfoResponse.value.filter(campaignInfo => {
          const campaignStartDate = moment(campaignInfo.fields.StartDate).local().format('YYYY-MM-DD');
          const campaignEndDate = moment(campaignInfo.fields.ExpiryDate).local().format('YYYY-MM-DD');
          return (moment(currentDate).local()).isSameOrAfter(moment(campaignStartDate).local())
              && (moment(currentDate).local()).isSameOrBefore(moment(campaignEndDate).local())

        });

        if (availableCampaigns && availableCampaigns.length > 0) {
          this.campaignExist = true;
          mostRecentCampaign = availableCampaigns[0];
        }
      }
      return mostRecentCampaign;
    },
    getDateStr(date) {
      let dateStrFormat = "dddd, MMMM D, YYYY"
      return moment(date).format(dateStrFormat);
    },
    navigateToCampaignPost() {
      if (this.bannerLink) {
        let subEvent = `${this.bannerTitle} - ${this.bannerLink.url}`
        this.trackCampaign(subEvent);
        window.open(this.bannerLink.url, Vue.prototype.$getAoneLinkTarget(this.bannerLink.url));
      }
    },
    navigateToCalendar() {
      if (this.bannerAdditionalInfo) {
        window.open(this.bannerAdditionalInfo.url, "_blank");
      }
    },
  },
};

async function getCampaignBannerImage(mostRecentCampaign) {
  let imageTag = mostRecentCampaign.eTag.replace("\"", "").split(",")
  let campaignImageResponse = await api.getCampaignImage(imageTag[0]);
  if (campaignImageResponse) {
    this.imgData = campaignImageResponse;
    let imgList = campaignImageResponse.value[0];
    // get imgData of first returned entry
    this.imgData = Object.entries(imgList)[0][1];
  }
}

function getBannerLinkDetails(mostRecentCampaign) {
  this.bannerLink = {};
  if (mostRecentCampaign.fields.BannerButton) {
    this.bannerLink.description = mostRecentCampaign.fields.BannerButton.Description;
    this.bannerLink.url = mostRecentCampaign.fields.BannerButton.Url;
  }
}

function getBannerAdditionalDetails(mostRecentCampaign) {
  this.bannerDate = mostRecentCampaign.fields.ExpiryDate
  this.bannerAdditionalInfo = {};
  if (mostRecentCampaign.fields.BannerAdditionalInfo) {
    this.bannerAdditionalInfo.description = mostRecentCampaign.fields.BannerAdditionalInfo.Description;
    this.bannerAdditionalInfo.url = mostRecentCampaign.fields.BannerAdditionalInfo.Url;
  }
}
</script>

<style scoped>
.campaign-card-wrapper {
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  min-height: 180px;
}

.campaign-title {
  font-family: artifaktElementExtraBold !important;
  font-style: normal;
  font-weight: 800;
  font-size: 30px;
  color: #FFFFFF;
  line-height: 1.0;
}

.campaign-btn {
  text-transform: none;
  font-family: artifaktElementExtraBold !important;
  font-weight: 800;
  font-size: 18px !important;
  line-height: 34px;
  color: #FFFFFF;
  padding: 12px 24px;
  background: #5F60FF;
  border-radius: 63px;
}

.campaign-btn:hover {
  cursor: pointer;
}

.campaign-date {
  font-family: artifaktElementRegular !important;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.4;
  color: #FFFFFF;
}

.campaign-container {
  padding-top: 44px;
  padding-bottom: 66px;
}

.greeting {
  font-family: artifaktElementRegular !important;
  font-style: normal;
  font-size: 30px;
  line-height: 1.0;
  margin-top: 3px;
  color: #FFFFFF;
}

.campaign-addition-link {
  text-decoration: underline;
}

.campaign-addition-link:hover {
  cursor: pointer;
}

.bg-black {
  background: #000;
}

.outage-wrapper {
  min-height: 52px;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/CampaignCard.vue